export default {
  返回: "Back",
  方案概述: "Solution Overview",
  方案价值: "Solution Value",
  方案架构图: "Solution Architecture Diagram",
  相关产品: "Related Products",
  典型案例: "Typical Cases",
  在线体验: "Online Experience",
  欢迎来到解决方案展厅: "Welcome to the Solution Showcase",
  "算能解决方案 助力数字中国建设，让国产算力普惠千行百业":
    "SOPHGO solutions empower the construction of Digital China, making domestic computing power accessible to thousands of industries",
  "面向丰富的业务场景，提供整套行业和技术解决方案，助力客户数字化转型":
    "Offering a comprehensive set of industry and technology solutions for a wealth of business scenarios to assist customers in their digital transformation",
  显示更多案例: "Show more cases",
  算丰赋能伙伴案例: "Case Study of SOPHON Empowerment Partner",
  了解详情: "Learn more",
  "（账号密码联系我们获取）": "(Contact us for account password)",
  项目咨询: "Project Consultation",
  "请填写以下表单，我们的销售代表会尽快与您联系":
    "Please fill out the following form, and our sales representative will contact you as soon as possible",
  工作邮箱: "Work Email",
  城市: "City",
  公司: "Company",
  行业: "Industry",
  需求: "Demand",
  请输入需求描述: "Please enter a description of your demand",
  "提交成功！我们会尽快与您联系":
    "Submitted successfully! We will contact you as soon as possible",
  联系我们: "Contact us",
  "项目咨询，可直接拨打": "For project inquiries, please call us directly",
  电话: "Phone Number",
  密码: "Password",
  姓名: "Name",
  邮箱: "Email",
  提交: "Submit",
  "将体验到VIP顾问式售前咨询，提供个性化解决方案":
    "Experience VIP consultant style pre-sales consultation and provide personalized solutions",
  步数: "Step count",
  权重: "Weights",
  强度: "Strength",
  随机的种子: "Random seed",
  欢迎来到智能书法: "Welcome to Smart Calligraphy",
  请输入文字: "Please Enter Text",
  "字体风格:": "Font style:",
  "生成中...": "Generating...",
  开始生成: "Start Generating",
  长按图片保存: "Long Press to Save Image",
  毛体: "hair body",
  王羲之体: "Wang Xizhi's Body",
  八大山人体: "Badashan Human Body",
  米芾体: "Mi Fu body",
  请填写: "Please fill",
};
